import { createFeatureSelector, createSelector } from '@ngrx/store';
import { searchFeatureKey, SearchState } from './search.reducer';

export const selectSearch =
    createFeatureSelector<SearchState>(searchFeatureKey);

export const selectCanSearchAgain = createSelector(
    selectSearch,
    (state: SearchState) => state.canSearchAgain
);

export const selectSearchAgain = createSelector(
    selectSearch,
    (state: SearchState) => state.searchAgain
);

export const selectSearchResults = createSelector(
    selectSearch,
    (state: SearchState) => state.searchResults
);

export const selectActiveSearchResult = createSelector(
    selectSearch,
    (state: SearchState) => state.activeSearchResult
);

export const selectSearchIsActive = createSelector(
    selectSearch,
    (state: SearchState) => state.searchIsActive
);

export const selectSearchQuery = createSelector(
    selectSearch,
    (state: SearchState) => state.query
);
